import styles from "../static/styles/vedtekter.module.css";

export default function Vedtekter() {
    
    return <>
        <div className="content-page">
            <div className={`${styles.content_wrap}`}>
                
                <div className={`${styles.vedtekter}`}>
                    <div className={`${styles.content_item}`}>
                        <h1>INNKALLING TIL ÅRSMØTE I BUSTADKLUBBEN I KVAM</h1>
                        <p className={`text`}>STAD: Gamleskulen i Norheimsund</p>
                        <p className={`text`}>TID: TYSDAG 24. Mars kl 19:00</p>
                    </div>
                    <div className={`${styles.content_item}`}>
                        
                        <div>
                            <h1>SAKSLISTE</h1>
                        </div>

                        <div className={`${styles.content_item}`}>
                            <ol className={`text`}><strong>Konstituering: </strong>
                                <li className={`text`}>Val av møteleiar og referent</li>
                                <li className={`text`}>Val av to personar til å underskrive protokollen</li>
                                
                            </ol>
                        </div>
                        
                        <ol>
                            <li>
                                <p className="text">
                                    1. Godkjenning av innkalling og saksliste
                                    
                                </p>
                            </li>
                            <li>
                                <p className="text">
                                    2. Godkjenning av referat frå Årsmøtet og ekstraordinært Årsmøte i 2025
                                    
                                </p>
                            </li>


                            <li>
                                <p className="text">
                                    3. Årsmelding for 2025 (Vedlegg 1)
                                </p>
                            </li>

                            <li>
                                <p className="text">
                                    4. Rekneskap for 2025
                                    (Vert utlevert på møtet)
                                </p>
                            </li>

                            <li>
                                <p className="text">
                                    5. Fastsetjing av satsar for innmeldingsavgift og årskontigent for 2026: <br></br>
                                    Styret føreslår uendra satsar.
                                </p>
                            </li>

                            <li>
                                <p className="text">
                                    6. Budsjett for 2026
                                    (Vert lagt fram på møtet)
                                </p>
                            </li>

                            <li>
                                <p className="text">
                                    7. Val med framlegg frå valnemnda.<br></br>
                                    Styret skal ha 5 medlemer og to varamedlemer.<br></br>
                                    Leiar vert vald for kvart år.
                                </p>
                            </li>

                            <li>
                                <p className="text">
                                    8. Vedtektsendring
                                    (Framlegg i vedlegg 2)
                                </p>
                            </li>

                            <li>
                                <p className="text">
                                    9. Moglege innmelde saker frå medlemmene.<br></br>
                                    Saker som medlemmene ønskjer å fremja på årsmøtet må vera styret i hende seinaste 14 dagar før årsmøtet,
                                    d.v.s. 10. mars.
                                </p>
                            </li>
                        </ol>
                        
                            <p className={`text`}>
                                Før møtet:
                            </p>
                        
                        
                        <ol>
                            <li className="text">
                            Før sjølve årsmøtet vil dagleg leiar for Hardanger Byggsenter AS, Hans Gravdal, orientera om prosjektet Monkabrotet i Øystese samt status på Homlabrotet / Solvang i Norheimsund.
                            </li>

                            <li className="text">
                            Helse- og sosialsjef Terje Langeland vil orientera om prosjektet «Framtidig behov for heildøgns omsorgsplassar i Kvam Herad».
                            </li>
                            <li className="text">Det blir enkel servering.</li>
                        </ol>


                        

                        
                    </div>
                    
                </div>
                
                    
            </div>
                
        </div>

    </>
}